import React from 'react';
import { Col, Row } from 'reactstrap';
import { Button } from '../Common';

const SuccessResetPassword = (props) => {
  const { email, backToSignIn } = props;
  return (
    <div role="alert">
      <p className="pBottom-15 margin-0">
        If <span className="bold-font">{email}</span> is associated with an account, you will receive an email with
        Instructions to reset your account password.
      </p>
      <div className="mBottom-15">
        <Button
          isNew
          stretch
          size="large"
          text="Back to Sign In"
          onClick={backToSignIn}
          classNames={['mBottom-20']}
          id='button-back-to-login'
        />
      </div>
      <Row>
        <Col xs={12}>
          If you have questions at any point, please visit the{' '}
          <span className="anchorParent">
            <a
              className="anchor"
              target="_blank"
              rel="noopener noreferrer"
              href="https://help.liaisonedu.com/Analytics">
              Help Center
            </a>
          </span>{' '}
          for FAQs and General Instructions.
        </Col>
      </Row>
    </div>
  );
};

export default SuccessResetPassword;
